import React from 'react'
import HTML from '../assets/html.png';
import JavaScript from '../assets/javascript.png';
import ReactImg from '../assets/react.png';
import GitHub from '../assets/github.png';
import Tailwind from '../assets/tailwind.png';
import Solidity from '../assets/Csolidityr.png';
import Flow from '../assets/flow.png'
import vs from '../assets/vs.png'

const Skills = () => {
  return (
    <div name='skills' className='w-full h-screen bg-[#0a192f] text-purple-500'>
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
            <div>
                <p className='text-4xl font-bold inline border-b-4 border-pink-600 '>Skills</p>
                <p className='py-4'> ( ) {'=>'} Some of the things I've used and worked with</p>
            </div>

            <div className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8 '>
                <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <a href="https://developer.mozilla.org/en-US/docs/Web/HTML"><img className='w-20 mx-auto' src={HTML} alt="html icon"/></a>
                    <p className='my-4'>HTML</p>
                </div>

                <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <a href="https://tailwindcss.com/"><img className='w-20 mx-auto' src={Tailwind} alt="html icon"/></a>
                    <p className='my-4'>Tailwind</p>
                </div>

                <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"><img className='w-20 mx-auto' src={JavaScript} alt="html icon"/></a>
                    <p className='my-4'>JavaScript</p>
                </div>

                <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <a href="https://reactjs.org/"><img className='w-20 mx-auto' src={ReactImg} alt="html icon"/></a>
                    <p className='my-4'>React</p>
                </div>

                <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <a href="https://docs.soliditylang.org/en/v0.8.16/"><img className='w-20 mx-auto  shadow-white h-18' src={Solidity}  alt="html icon"/></a>
                    <p className='my-4'>Solidity</p>
                </div>

                <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <a href="https://github.com/"><img className='w-20 mx-auto' src={GitHub} alt="html icon"/></a>
                    <p className='my-4'>GitHub</p>
                </div>

                <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <a href="https://developers.flow.com/cadence/language"><img className='w-20 mx-auto' src={Flow} alt="html icon"/></a>
                    <p className='my-4'>Cadence Lang</p>
                </div>

                <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500'>
                    <a href="https://code.visualstudio.com/"><img className='w-20 mx-auto' src={vs} alt="html icon"/></a>
                    <p className='my-4'>VS Code</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Skills